/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';

import { UomDetailsBusinessService } from '../../resources/uom-details-business.service';
import { UomDetailsDialogComponent } from './uom-details-dialog.component';

export const uomDialog = createDialogRoute({
  component: UomDetailsDialogComponent,
  init: UomDetailsBusinessService,
});
